import { Buffer } from 'buffer';
 
export const encrypt = (data) => {
    const json = JSON.stringify(data);
    const encoded = encodeURIComponent(json);
    return Buffer.from(encoded, 'utf8').toString('base64');
  };
  
  export const decrypt = (data) => {
    const decoded = Buffer.from(data, 'base64').toString('utf8');
    const json = decodeURIComponent(decoded);
    return JSON.parse(json);
  };
  